module.exports = __webpack_public_path__ + "static/media/WoundsThreshold.01f4d103.svg";